import React from 'react';
import {checkUserRight, compose, convertFromErrorObject, getAllModalFunctions} from "../../../utils";
import {withTranslation} from "react-i18next";
import {withTLService} from "../../hoc";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {adminGetAllCompanies, adminGetAllOptions} from "../../../actions";

import {Button} from "react-bootstrap";
import DataViewer from "../../elements/data-viewer";
import ModalAddEditAllowlist from "../../modals/modal-add-edit-allowlist";


class Allowlists extends DataViewer {


    /*  define count of modal*/
    modalWindowsCount = 2;

    tableFilters = {
        deleted: {
            name: 'Show deleted elements',
            type: 'integer',
            default: 0
        },
        words: {
            name: 'Filter by words',
            type: 'string',
            default: undefined
        },
        lemma: {
            name: 'Filter by lemmas',
            type: 'string',
            default: undefined
        },
        id: {
            name: 'Term id',
            type: 'integer',
            default: undefined
        },
        description: {
            name: 'Term description',
            type: 'string',
            default: undefined
        },
        term_category_id: {
            name: 'List category id',
            type: 'integer',
            default: undefined
        },
        state: {
            name: 'state',
            type: 'select',
            dir: [
                [0,'Pending'],
                [1,'Approved'],
                [2,'Disapproved']
            ],
            default: 0
        }
    }

    functions = {
        getAll: this.props.tlService.getFilteredAllowLists,
        massDelete: data => this.actionMassDelete(data),
        massApprove: data => this.actionMassApprove(data),
        approveAll: data => this.actionApproveAll(data)
    };

    modalComponents = {
        modalAdd: ModalAddEditAllowlist,
        modalEdit: ModalAddEditAllowlist,
        modalView: ModalAddEditAllowlist,
    };

    componentDidMount() {
        const {
            userData: {user},
            t: translate
        } = this.props;

        const status = [translate('Pending'),translate('Approved'),translate('Disapproved')];

        /* default table columns config */
        this.columns_default = [
            {
                name: 'id',
                selector: 'id',
                sortable: true
            },
            {
                name: 'term_category_name',
                selector: 'term_category_name',
                cell: row => row.term_category_name[this.props.i18n.language]
            },
            {
                name: 'check_words',
                selector: 'check_words',
                cell: row => row.check_words === 1 ? 'by word' : 'by lemma'
            },
            {
                name: 'words',
                selector: 'words',
                cell: row => row.words
            },
            {
                name: 'lemma',
                selector: 'lemma',
                cell: row => row.lemma
            },
            {
                name: 'state',
                selector: 'state',
                cell: row => status[row.state] !== undefined ? status[row.state] : row.state
            }
        ];

        this.columns_default.push({
            name: 'edit',
            cell: row => {
                return (
                    <div className="btn-group">
                        {checkUserRight(user, []) &&
                            (<>
                                <Button onClick={() => this.openModal(0, row, 'modalEdit')} className="ml-2"><i className="fas fa-edit"/></Button>
                                <Button onClick={() => this.openModal(0, row, 'modalApprove')} className="ml-2"><i
                                    className="fas fa-check"/></Button>
                                <Button onClick={() => this.openModal(0, row, 'modalDelete')} className="ml-2"><i
                                    className="fas fa-trash"/></Button>
                            </>)

                        }
                    </div>
                )
            }
        });


        // check for enable page
        this.renderIt = checkUserRight(user, []);

        // check add right
        this.addButton = false


        //this.props.adminGetAllCompanies(token);
        //this.props.adminGetAllOptions(token);


        this.modalSettings['modalAdd'] = {
            action: this.actionAdd,
            data: {
                name: '',
                company_id: 1,
                user_group_options: {}
            },
            show: false,
            header: translate('Add Group'),
            footer: true,
            text: '',
            saveButton: true,
            saveButtonText: translate('Save'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        };
        this.modalSettings['modalEdit'] = {
            action: this.actionEdit,
            data: {
                name: '',
                company_id: 1,
                user_group_options: {}
            },
            show: false,
            header: translate('Edit Entry'),
            footer: true,
            text: '',
            saveButton: true,
            saveButtonText: translate('Save'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        };
        this.modalSettings['modalApprove'] = {
            action: this.actionApprove,
            data: {
                name: '',
                company_id: 1,
                user_group_options: {}
            },
            show: false,
            header: translate('Approve term'),
            footer: true,
            text: '',
            saveButton: true,
            saveButtonText: translate('Approve'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        };
        this.modalSettings['modalView'] = {
            action: false,
            data: {
                name: '',
                company_id: 1,
                user_group_options: {}
            },
            show: false,
            header: translate('View Group'),
            footer: true,
            text: '',
            saveButton: false,
            saveButtonText: translate('Save'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        };
        this.modalSettings['modalDelete'] = {
            action: this.actionDelete,
            data: {
                id: false,
            },
            show: false,
            header: translate('Delete Entry'),
            footer: true,
            text: translate('Delete Entry'),
            saveButton: true,
            saveButtonText: translate('Delete'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        };
        this.modalSettings['modalMassDelete'] = {
            action: this.actionDoMassDelete,
            data: {},
            show: false,
            header: translate('Delete Selected Allow List'),
            footer: true,
            text: translate('Delete Selected Allow List'),
            saveButton: true,
            saveButtonText: translate('Delete'),
            closeButton: true,
            closeButtonText: translate('Close'),
            ok: true
        }
        this.modalSettings['modalMassApprove'] = {
            action: this.actionDoMassApprove,
            data: {},
            show: false,
            header: translate('Approve Selected Terms'),
            footer: true,
            text: translate('Approve Selected Terms'),
            saveButton: true,
            saveButtonText: translate('Approve'),
            closeButton: true,
            closeButtonText: translate('Approve'),
            ok: true
        }

        this.setState({
            filters: {
                state: 0
            },
            limits: {
                limit: 10,
                offset: 0,
                order_by: 'id',
                order: 0
            },
            page: {
                pageHeader: translate('Allow List'),
                addNewText: translate('Add new Allow List'),
            }
        });
        super.componentDidMount();
    }

    actionMassApprove(data) {
        if (data.length > 0)
            this.openModal(this.props.index !== undefined ? this.props.index + 1 : 0, data, 'modalMassApprove')
    }

    actionDoMassApprove = async (data) => {
        for (let id of data) {
            await this.actionApprove(id)
        }
        this.getAllData();
        return true;
    }

    actionAdd = async (data) => {
         return true;
    }

    actionApprove = async (data) => {
        const {t} = this.props;
        const {
            tlService,
            userData: {token},
        } = this.props;
        let words, lemma, tag;
        try {
            words = typeof data.words === 'string' ? JSON.parse(data.words) : data.words;
            lemma = typeof data.lemma === 'string' ? JSON.parse(data.lemma) : data.lemma;
            tag = typeof data.tag === 'string' ? JSON.parse(data.tag) : data.tag;
        } catch (e) {
            words = [];
            lemma = [];
            tag = [];
        }
        try {
            await tlService.addTermInCategory(token, data.term_category_id,
                {
                    words,
                    lemma,
                    tag,
                    check_words: !!data.check_words ? 1 : 0
                });
            await tlService.clearAllCache(token, 1, parseInt(data.term_category_id));
        } catch (e) {
            console.log('error ' + convertFromErrorObject(t,e));
            this.setState({error: convertFromErrorObject(t,e)});
            return false;
        }

        try {
            await tlService.updateWhitelist(token, data.id,
                {
                    state: 1,
                });

        } catch (e) {
            console.log('error ' + convertFromErrorObject(t,e));
            this.setState({error: convertFromErrorObject(t,e)});
            return false;
        }
        return true;
    }

    actionEdit = async (data) => {
        const {t} = this.props;
        const {
            tlService,
            userData: {token},
        } = this.props;
        let words, lemma, tag;
        try {
            words = typeof data.words === 'string' ? JSON.parse(data.words) : data.words;
            lemma = typeof data.lemma === 'string' ? JSON.parse(data.lemma) : data.lemma;
            tag = typeof data.tag === 'string' ? JSON.parse(data.tag) : data.tag;
        } catch (e) {
            words = [];
            lemma = [];
            tag = [];
        }
        try {
            await tlService.updateWhitelist(token, data.id,
                {
                    term_category_id: parseInt(data.term_category_id),
                    lemma: lemma,
                    check_words: parseInt(data.check_words),
                    tag: tag,
                    words: words,
                });

        } catch (e) {
            console.log('error ' + convertFromErrorObject(t,e));
            this.setState({error: convertFromErrorObject(t,e)});
            return false;
        }
        return true;
    }

    actionDelete = async (data) => {
        const {t} = this.props;
        const {
            tlService,
            userData: {token},
        } = this.props;

        try {
            await tlService.deleteWhitelist(token, parseInt(data.id));
        } catch (e) {
            console.log('error ' + convertFromErrorObject(t,e));
            this.setState({error: convertFromErrorObject(t,e)});
            return false;
        }

        return true;
    }

}

const mapStateToProps = ({userData, modalData, openData, adminData}) => {
    return {userData, openData, modalData, adminData};
};

const mapDispatchToProps = (dispatch, {tlService}) => {
    return bindActionCreators({
        ...getAllModalFunctions(),
        adminGetAllCompanies: adminGetAllCompanies(tlService),
        adminGetAllOptions: adminGetAllOptions(tlService)

    }, dispatch);
};

export default compose(
    withTranslation(),
    withTLService(),
    connect(mapStateToProps, mapDispatchToProps)
)(Allowlists);
